import actions from './action.js'
export default {
	namespaced: true,
    actions: actions,
}